import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentComerciantes } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class EducationMaterialService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environmentComerciantes.apiUrl}/Educationalmaterial/get`);
    }

    getID(id) {
        return this.http.get(`${environmentComerciantes.apiUrl}/Educationalmaterial/getbyid?id=` + id);
    }

    getUrlFile(){
        return `${environmentComerciantes.urlFile}`
    }

    post(food) {
        return this.http.post<any>(`${environmentComerciantes.apiUrl}/Educationalmaterial/InsertOrUpdate`, food);
    }

}
